import BaseWebSocketSubscriber from './base.websocket.subscriber'

const MESSAGE_TYPES = {
  SESSION_ENDED: 'session-ended',
  REPLAY_SHARED: 'replay-shared',
}

class ReplayWebSocketSubscriber extends BaseWebSocketSubscriber {
  init() {
    this.socketClient.on(MESSAGE_TYPES.SESSION_ENDED, this.onSessionEnded.bind(this))
    this.socketClient.on(MESSAGE_TYPES.REPLAY_SHARED, this.onReplayShared.bind(this))
  }

  onSessionEnded(data) {
    this.$store.commit('replay/setSessionEnded', { ...data, source: 'session_ended' })
  }

  onReplayShared(data) {
    this.$store.commit('replay/setSessionEnded', { ...data, source: 'presenter_shared' })
  }
}

export default ReplayWebSocketSubscriber
